import React from "react";
import DocList from "../../_components/Sales/SalesDocList";
import {
    FiCheckCircle, FiClock, FiFileText,
    FiXCircle, FiUser, FiDollarSign, FiTag,
    FiHome, FiSlash
} from "react-icons/fi";
import { T, fmtMYR, fmtCurrency } from "../../_components/Sales/SalesShared";
import { getDebitNotes, getDNKpis, deleteDebitNote, getDNById } from "../../_services/finance.service";


export default function DebitNotes() {
    return (
        <DocList
            docType="Debit Note"
            basePath="/finance/debit-notes"
            fetchList={getDebitNotes}
            bulkPrint={{ fetchById: getDNById }}
            fetchKpis={getDNKpis}
            deleteItem={deleteDebitNote}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected", "Cancelled"]}
            kpiCards={[
                { label: "Total Debit Notes", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
                { label: "Cancelled", key: "cancelled", icon: FiSlash, color: T.textMuted },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiHome, label: "Company Name", key: "customer" },
                { icon: FiFileText, label: "Invoice Ref.", key: "invoiceId" },
                { icon: FiTag, label: "Reason", key: "reason" },
                { icon: FiDollarSign, label: "Debit Amount", key: "grandTotal", render: (v,row) => fmtCurrency(v, row.currency) },
            ]}
            totalLabel="Debit Amount"
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "DN No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "customer", label: "Company Name" },
                { key: "grandTotal", label: "Debit Amount" },
            ]}
        />
    );
}
